/**
 * @pageName BookingList
 * @slotType dashboard plugin
 */
export type BookingListHeaderParams = {};

/**
 * @pageName BookingList
 * @slotType dashboard plugin
 */
export interface BookingListMenuActionParams {
  bookingId?: string;
}

/**
 * @pageName BookingList
 * @slotType dashboard plugin
 */
export interface BookingListBulkMenuActionParams {
  selectedBookingIds: string[];
}
